import { useAuth } from "~/store/auth";
import { useSettings } from "~/store/settings";
import api from "./auth/api";
import { parseJwt } from "./parseJWT";
import type { IChatPriority } from "~/types/chat/chatPriority";

const openLiveChat = () => {
	const settings = useSettings();
	const auth = useAuth();
	const router = useRouter();
	const liveChatId = computed(() => {
		const liveChatUrl = settings.config?.devConfig.liveChat && new URL(settings.config?.devConfig.liveChat);
		const liveChatSearchParams = new URLSearchParams(liveChatUrl?.searchParams);
		return `cnx_it_livechat-betway${liveChatSearchParams.get("connid")}`;
	});
	let liveChatInterval: NodeJS.Timeout | null = null;

	const liveChatAddNote = () => {
		liveChatInterval = setInterval(() => {
			try {
				const liveChatCookie = useCookie<string>(liveChatId.value);
				const interactionId = parseJwt(liveChatCookie.value).sub;
				if (liveChatCookie.value && !sessionStorage.getItem("liveChatSetNote")) {
					api({
						url: `/LiveChat/AddLiveChatNote?interactionId=${interactionId}`,
						type: "api",
						options: {
							method: "POST",
						},
						data: {
							message: "Platform: Synapse; AppType: Web;",
							message_type: "note",
						},
					}).then(() => {
						sessionStorage.setItem("liveChatSetNote", "true");
						if (liveChatInterval) clearInterval(liveChatInterval);
					});
				} else if (sessionStorage.getItem("liveChatSetNote")) {
					if (liveChatInterval) clearInterval(liveChatInterval);
				}
			} catch (e) {}
		}, 5000);
	};

	const open = async () => {
		try {
			if (auth.loggedIn && auth.profile?.id) {
				try {
					const res = await api<IChatPriority>({
						url: `/LiveChat/GetLiveChatRouting`,
						type: "api",
						options: {
							method: "GET",
							headers: {
								"x-accountId": auth.profile?.id,
							},
						},
					});
					window.__CONNEXONE_LIVECHAT__?.authenticateCustomer({
						firstname: auth.profile?.metaData?.firstName,
						tel1: "+" + auth.profile?.username,
						lead_reference: "p" + res.overallScore,
					});
				} catch (error) {
					window.__CONNEXONE_LIVECHAT__?.authenticateCustomer({
						firstname: auth.profile?.metaData?.firstName,
						tel1: "+" + auth.profile?.username,
						lead_reference: "p10",
					});
				}
			}
			window.__CONNEXONE_LIVECHAT__.openWidget();
			settings.liveChatLoading = false;
		} catch (e) {
			console.log("Unable to open livechat");
		}
	};
	try {
		if (settings.liveChatLoaded) {
			open();
		} else {
			const liveChat = settings.config?.devConfig.liveChat;
			if (liveChat) {
				settings.liveChatLoading = true;
				const head = document.getElementsByTagName("head")[0];
				const script = document.createElement("script");
				script.type = "text/javascript";
				script.src = liveChat;
				script.id = "livechat-betway";
				script.setAttribute("data-socket-uri", "https://livechat-betway.connexone.co.uk");
				script.setAttribute("async", "");
				script.setAttribute("defer", "");
				head.appendChild(script);
				settings.liveChatLoaded = true;
				window.__CONNEXONE_LIVECHAT_HOOKS__ = {
					onLoad() {
						const nudge = document.getElementById("cx-nudge");
						const chat = document.getElementById("cx-chat");
						if (nudge) nudge.style.display = "none";
						if (chat) chat.style.display = "none";
						const checkLoading = setInterval(() => {
							if (document.getElementById("cx-nudge")) {
								clearInterval(checkLoading);
								settings.liveChatLoaded = true;
								open();
							}
						}, 500);
					},
					onWidgetClosed() {
						if (liveChatInterval) clearInterval(liveChatInterval);
						const nudge = document.getElementById("cx-nudge");
						const chat = document.getElementById("cx-chat");
						if (nudge) nudge.style.display = "none";
						if (chat) chat.style.display = "none";
						router.push({ query: {} });
					},
					onWidgetHidden() {
						const nudge = document.getElementById("cx-nudge");
						const chat = document.getElementById("cx-chat");
						if (nudge) nudge.style.display = "none";
						if (chat) chat.style.display = "none";
					},
					onWidgetOpened() {
						liveChatAddNote();
						if (settings.liveChatCanceled) {
							window.__CONNEXONE_LIVECHAT__.closeWidget();
							settings.liveChatCanceled = false;
						}

						const nudge = document.getElementById("cx-nudge");
						const chat = document.getElementById("cx-chat");
						if (nudge) nudge.style.display = "block";
						if (chat) chat.style.display = "block";
					},
					onWidgetShown() {},
				};
			}
		}
	} catch (e) {
		console.log("Unable to initialize liveChat");
	}
};

export { openLiveChat };
